import React from "react";

import PageMessage from "2g-page-message";
import { isNotEmpty } from "2g-utils-common";

import { useServerMessage } from "b2b/i18n";
import TypyZdrojuSwitch from "b2b/components/form-switches/TypyZdrojuSwitch";
import ZdrojeSwitch from "b2b/components/form-switches/ZdrojeSwitch";
import ProduktySwitch from "b2b/components/form-switches/ProduktySwitch";
import useRezervaceVytvoreniProdukt from "./hooks/useRezervaceVytvoreniProdukt";

export function RezervaceVytvoreniProdukt() {
  const message = useServerMessage();
  const { typZdroje, zdroj, produkt, isVisible } =
    useRezervaceVytvoreniProdukt();
  return isVisible ? (
    <>
      <TypyZdrojuSwitch />
      {typZdroje ? <ZdrojeSwitch typZdroje={typZdroje} /> : undefined}
      {zdroj ? <ProduktySwitch zdroj={zdroj} /> : undefined}
      {isNotEmpty(produkt?.produkt?.popisCs) ? (
        <PageMessage inline className="b2b-Rezervace-popisProduktu">
          {message(produkt.produkt, "popis")}
        </PageMessage>
      ) : undefined}
    </>
  ) : undefined;
}

export default React.memo(RezervaceVytvoreniProdukt);
